import { CounterLabel } from '@euler/app/flows/settings/components/CounterLabel';
import { useBluetoothGatewayDeviceCount } from '@euler/app/flows/settings/functions';
import { memo } from 'react';

export const BluetoothGatewayDeviceCountNote = memo(() => {
  const count = useBluetoothGatewayDeviceCount();
  return <CounterLabel value={count} />;
});
